import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-the-a01-message-panel__heading" }
const _hoisted_2 = { class: "p-the-a01-message-panel__body" }
const _hoisted_3 = { class: "p-the-a01-message-panel__list" }
const _hoisted_4 = { class: "p-the-a01-message-panel__more" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "p-the-a01-message-panel__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpTooltip = _resolveComponent("HelpTooltip")!
  const _component_A01MessageListPanel = _resolveComponent("A01MessageListPanel")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", {
    class: "p-the-a01-message-panel",
    style: _normalizeStyle({
      '--site-light-color': _ctx.lightColorCode
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-a01-message-panel__title" }, "最新のやりとり", -1)),
      _createVNode(_component_HelpTooltip, { text: _ctx.latestMessageTooltip }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.hasMessages)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, key) => {
                return (_openBlock(), _createBlock(_component_A01MessageListPanel, {
                  key: key,
                  message: message
                }, null, 8, ["message"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", {
                href: _ctx.url,
                class: "p-the-a01-message-panel__more-link"
              }, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "p-the-a01-message-panel__more-label" }, " 過去のやりとりをもっと見る ", -1)),
                _createVNode(_component_IconBase, {
                  class: "p-the-a01-message-panel__more-icon",
                  width: 24,
                  height: 24,
                  "view-box": "0 0 24 24",
                  "icon-color": _ctx.colorCode
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowRight)
                  ]),
                  _: 1
                }, 8, ["icon-color"])
              ], 8, _hoisted_5)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, " まだやりとりはありません。日頃の感謝を伝えてみませんか？ "))
    ])
  ], 4))
}